import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ccPaymentReportModel } from '../models/ccPaymentReportModel';

@Injectable({
  providedIn: 'root'
})
export class CcPaymentReportService {
  Value : any ;

  constructor(private _http: HttpClient) { }

  getCcPaymentReportFranchiseList(): Observable<any> {
    return this._http.get<any>(environment.config.BASE_API_URL + 'CustomerWiseInvoices/GetBlankSearchModel');
    
  }

  getCcPaymentReport(ccPaymentReportSearchCriteria:ccPaymentReportModel): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'CustomerWiseInvoices/PostCustomerWiseInvoicesSummary', ccPaymentReportSearchCriteria);
  }

}
